import { CheckCircle, Clock, CalendarX, Question } from "@phosphor-icons/react";

const META = {
  active: { label: "Active", cls: "text-emerald-700 bg-emerald-50 border-emerald-200", Icon: CheckCircle },
  stale: { label: "Needs re-check", cls: "text-orange-700 bg-orange-50 border-orange-200", Icon: Clock },
  deadline_passed: { label: "Deadline passed", cls: "text-red-700 bg-red-50 border-red-200", Icon: CalendarX },
  unknown: { label: "Freshness unknown", cls: "text-slate-600 bg-slate-50 border-slate-200", Icon: Question },
};

export function FreshnessBadge({ freshness, showActive = false }) {
  if (!freshness) return null;
  if (freshness.status === "active" && !showActive) return null;
  const m = META[freshness.status] || META.unknown;
  const Icon = m.Icon;
  return (
    <span data-testid={`freshness-${freshness.status}`}
      className={`inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-medium ${m.cls}`}>
      <Icon weight="bold" className="h-3 w-3" /> {freshness.label || m.label}
    </span>
  );
}
